module.exports = "subu $t7, $t1, $t0\nsubu $t8, $t2, $t1\nsubu $t9, $t0, $t1\n"